export function getExportTooltip() {
  return (
    <>
      Export capability is provided as a value add in Click & Go. Exported data is not intended to
      be used for any type of mass communication efforts
    </>
  )
}
